// extracted by mini-css-extract-plugin
export default {"outer-box":"E05NteD1vc0gOut5Gs_g","outer-box-main":"UAKuFqNRNdcJo8q6HLUk","type-default":"EPQ3wDJPZvv5PGWEKlyR","common_bganimation":"dQB0kNy3rnp23JImn_ub"};